unit View.Funcionarios.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewFuncionariosList = class(TForm)
    btNew: TButton;
    FuncionariosDataset: TXDataWebDataSet;
    FuncionariosDatasetid: TIntegerField;
    FuncionariosDatasetaliado_id: TIntegerField;
    FuncionariosDatasetdata_base_id: TIntegerField;
    FuncionariosDatasetnome: TStringField;
    FuncionariosDatasettelefone1: TStringField;
    FuncionariosDatasettelefone2: TStringField;
    FuncionariosDatasetemail: TStringField;
    FuncionariosDatasetcadastro: TDateTimeField;
    FuncionariosDatasetstatus: TIntegerField;
    FuncionariosDatasetcodigo_interno: TIntegerField;
    FuncionariosDatasetexcluido: TBooleanField;
    FuncionariosDatasetinclusao: TDateTimeField;
    FuncionariosDatasetalteracao: TDateTimeField;
    FuncionariosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewFuncionariosList: TFViewFuncionariosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFuncionariosList }

procedure TFViewFuncionariosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewFuncionariosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFuncionariosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewFuncionariosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewFuncionariosList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewFuncionariosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewFuncionariosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      FuncionariosDataset.Connection.Model.DefaultSchema.FindEntityType(FuncionariosDataset.EntitySetName),
      FuncionariosDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewFuncionariosList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('funcionarios', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    FuncionariosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewFuncionariosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.funcionarios.list.pagination.info');
  btNew := TButton.Create('view.funcionarios.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.funcionarios.list.table');
  cbPageSize := TComboBox.Create('view.funcionarios.list.cbPageSize');
  edSearch := TEdit.Create('view.funcionarios.list.search');
  lcPaginator := TListControl.Create('view.funcionarios.list.pagination');
  FuncionariosDataset := TXDataWebDataSet.Create(Self);
  FuncionariosDatasetid := TIntegerField.Create(Self);
  FuncionariosDatasetaliado_id := TIntegerField.Create(Self);
  FuncionariosDatasetdata_base_id := TIntegerField.Create(Self);
  FuncionariosDatasetnome := TStringField.Create(Self);
  FuncionariosDatasettelefone1 := TStringField.Create(Self);
  FuncionariosDatasettelefone2 := TStringField.Create(Self);
  FuncionariosDatasetemail := TStringField.Create(Self);
  FuncionariosDatasetcadastro := TDateTimeField.Create(Self);
  FuncionariosDatasetstatus := TIntegerField.Create(Self);
  FuncionariosDatasetcodigo_interno := TIntegerField.Create(Self);
  FuncionariosDatasetexcluido := TBooleanField.Create(Self);
  FuncionariosDatasetinclusao := TDateTimeField.Create(Self);
  FuncionariosDatasetalteracao := TDateTimeField.Create(Self);
  FuncionariosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  FuncionariosDataset.BeforeLoadDFMValues;
  FuncionariosDatasetid.BeforeLoadDFMValues;
  FuncionariosDatasetaliado_id.BeforeLoadDFMValues;
  FuncionariosDatasetdata_base_id.BeforeLoadDFMValues;
  FuncionariosDatasetnome.BeforeLoadDFMValues;
  FuncionariosDatasettelefone1.BeforeLoadDFMValues;
  FuncionariosDatasettelefone2.BeforeLoadDFMValues;
  FuncionariosDatasetemail.BeforeLoadDFMValues;
  FuncionariosDatasetcadastro.BeforeLoadDFMValues;
  FuncionariosDatasetstatus.BeforeLoadDFMValues;
  FuncionariosDatasetcodigo_interno.BeforeLoadDFMValues;
  FuncionariosDatasetexcluido.BeforeLoadDFMValues;
  FuncionariosDatasetinclusao.BeforeLoadDFMValues;
  FuncionariosDatasetalteracao.BeforeLoadDFMValues;
  FuncionariosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewFuncionariosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'telefone1';
      Title := 'telefone1';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'telefone2';
      Title := 'telefone2';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'email';
      Title := 'email';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cadastro';
      Title := 'cadastro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status';
      Title := 'status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    FuncionariosDataset.SetParentComponent(Self);
    FuncionariosDataset.Name := 'FuncionariosDataset';
    FuncionariosDataset.EntitySetName := 'Funcionarios';
    FuncionariosDataset.Connection := DMConnection.ApiConnection;
    FuncionariosDataset.Left := 72;
    FuncionariosDataset.Top := 144;
    FuncionariosDatasetid.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetid.Name := 'FuncionariosDatasetid';
    FuncionariosDatasetid.FieldName := 'id';
    FuncionariosDatasetid.Required := True;
    FuncionariosDatasetaliado_id.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetaliado_id.Name := 'FuncionariosDatasetaliado_id';
    FuncionariosDatasetaliado_id.FieldName := 'aliado_id';
    FuncionariosDatasetaliado_id.Required := True;
    FuncionariosDatasetdata_base_id.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetdata_base_id.Name := 'FuncionariosDatasetdata_base_id';
    FuncionariosDatasetdata_base_id.FieldName := 'data_base_id';
    FuncionariosDatasetdata_base_id.Required := True;
    FuncionariosDatasetnome.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetnome.Name := 'FuncionariosDatasetnome';
    FuncionariosDatasetnome.FieldName := 'nome';
    FuncionariosDatasetnome.Required := True;
    FuncionariosDatasetnome.Size := 255;
    FuncionariosDatasettelefone1.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasettelefone1.Name := 'FuncionariosDatasettelefone1';
    FuncionariosDatasettelefone1.FieldName := 'telefone1';
    FuncionariosDatasettelefone1.Size := 255;
    FuncionariosDatasettelefone2.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasettelefone2.Name := 'FuncionariosDatasettelefone2';
    FuncionariosDatasettelefone2.FieldName := 'telefone2';
    FuncionariosDatasettelefone2.Size := 255;
    FuncionariosDatasetemail.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetemail.Name := 'FuncionariosDatasetemail';
    FuncionariosDatasetemail.FieldName := 'email';
    FuncionariosDatasetemail.Size := 255;
    FuncionariosDatasetcadastro.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetcadastro.Name := 'FuncionariosDatasetcadastro';
    FuncionariosDatasetcadastro.FieldName := 'cadastro';
    FuncionariosDatasetstatus.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetstatus.Name := 'FuncionariosDatasetstatus';
    FuncionariosDatasetstatus.FieldName := 'status';
    FuncionariosDatasetstatus.Required := True;
    FuncionariosDatasetcodigo_interno.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetcodigo_interno.Name := 'FuncionariosDatasetcodigo_interno';
    FuncionariosDatasetcodigo_interno.FieldName := 'codigo_interno';
    FuncionariosDatasetcodigo_interno.Required := True;
    FuncionariosDatasetexcluido.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetexcluido.Name := 'FuncionariosDatasetexcluido';
    FuncionariosDatasetexcluido.FieldName := 'excluido';
    FuncionariosDatasetinclusao.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetinclusao.Name := 'FuncionariosDatasetinclusao';
    FuncionariosDatasetinclusao.FieldName := 'inclusao';
    FuncionariosDatasetalteracao.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetalteracao.Name := 'FuncionariosDatasetalteracao';
    FuncionariosDatasetalteracao.FieldName := 'alteracao';
    FuncionariosDatasetexclusao.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetexclusao.Name := 'FuncionariosDatasetexclusao';
    FuncionariosDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := FuncionariosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    FuncionariosDataset.AfterLoadDFMValues;
    FuncionariosDatasetid.AfterLoadDFMValues;
    FuncionariosDatasetaliado_id.AfterLoadDFMValues;
    FuncionariosDatasetdata_base_id.AfterLoadDFMValues;
    FuncionariosDatasetnome.AfterLoadDFMValues;
    FuncionariosDatasettelefone1.AfterLoadDFMValues;
    FuncionariosDatasettelefone2.AfterLoadDFMValues;
    FuncionariosDatasetemail.AfterLoadDFMValues;
    FuncionariosDatasetcadastro.AfterLoadDFMValues;
    FuncionariosDatasetstatus.AfterLoadDFMValues;
    FuncionariosDatasetcodigo_interno.AfterLoadDFMValues;
    FuncionariosDatasetexcluido.AfterLoadDFMValues;
    FuncionariosDatasetinclusao.AfterLoadDFMValues;
    FuncionariosDatasetalteracao.AfterLoadDFMValues;
    FuncionariosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
